import React, { useEffect, useState } from "react";
import Button from "../../components/ui/Button";
import { useNavigate } from "react-router-dom";

const ProductGrid = () => {
  // const products = [
  //   {
  //     id: 1,
  // image: "/assets/card1.png",
  // category: "Organic Fertilizer",
  // title: "Utpann Kesari Phos",
  // weight: "Net Weight 50 Kg",
  //   },
  //   {
  //     id: 2,
  //     image: "/assets/card1.png",
  //     category: "Fermented",
  //     title: "Organic Manure",
  //     weight: "Net Weight 30 Kg",
  //   },
  //   {
  //     id: 3,
  //     image: "/assets/card1.png",
  //     category: "Fermented Organic Manure",
  //     title: "Garden Nest",
  //     weight: "Net Weight 50 Kg",
  //   },
  // ];
  const products = [
    {
      id: 1,
      image: "/assets/productImage/img-10.png",
      category: "Fermented Organic Manure (FOM)",
      title: "Organic Manure",
      weight: "Net Weight 30 Kg",
      path: "/UtpannOrganicManure",
    },
    {
      id: 2,
      image: "/assets/productImage/img-11.png",
      category: "Phosphate Rich Organic Manure (PROM)",
      title: "Utpann Kesari Phos",
      weight: "Net Weight 50 Kg",
      path: "/UtpannKesariPhos",
    },
    {
      id: 3,
      image: "/assets/productImage/img-12.png",
      category: "Fermented Organic Manure (FOM)",
      title: "Garden Nest",
      weight: "Net Weight 5 Kg",
      path: "/UtpannGardenNest",
    },
    {
      id: 4,
      image: "/assets/productImage/img-9.png",
      category: "Liquid Fermented Organic Manure (LFOM)",
      title: "Utpann Plant Booster",
      weight: "Net Weight 10ltr / 20ltr / 50ltr",
      path: "/UtpannPlantBooster",
    },

    {
      id: 5,
      image: "/assets/productImage/img-1.png",
      category: "Liquid Fermented Organic Manure (LFOM)",
      title: "Utpann Super",
      weight: "Net Weight 1ltr / 5ltr",
      path: "/UtpannSuper",
    },
    {
      id: 6,
      image: "/assets/productImage/img-2.png",
      category: "Bio-stimulant",
      title: "Utpann PRO",
      weight: "Net Weight 1ltr",
      path: "/UtpannPRO",
    },
    {
      id: 7,
      image: "/assets/productImage/img-8.png",
      category: "Mycorrhizal Bio Fertilizer",
      title: "Utpann U-max",
      weight: "Net Weight 2kg / 4kg / 30kg",
      path: "/UtpannUMax",
    },
    {
      id: 8,
      image: "/assets/productImage/img-3.png",
      category: "Plant Immunity Booster",
      title: "Utpann Defensio",
      weight: "Net Weight 1ltr",
      path: "/UtpannDefensio",
    },
    {
      id: 9,
      image: "/assets/productImage/img-4.png",
      category: "Zinc Solubilizing Bacteria",
      title: "Utpann ZSB",
      weight: "Net Weight 500gm",
      path: "/UtpannZSB",
    },
    {
      id: 10,
      image: "/assets/productImage/img-5.png",
      category: "Mycorrhizal Bio Fertilizer",
      title: "Utpann MYCO",
      weight: "Net Weight 100gm",
      path: "/UtpannMYCO",
    },
    {
      id: 11,
      image: "/assets/productImage/img-6.png",
      category: "Carrier Based Consortia",
      title: "Utpann CBC-19",
      weight: "Net Weight 500gm / 1kg",
      path: "/UtpannCBC-19",
    },
    {
      id: 12,
      image: "/assets/productImage/img-7.png",
      category: "Phosphate Solubilizing Fungal",
      title: "Utpann PSF",
      weight: "Net Weight 500gm",
      path: "/UtpannPSF",
    },

    // ... बाकी डेटा यहाँ रखें
  ];
  const [isHeaderMenuOpen, setIsHeaderMenuOpen] = useState(false);

  useEffect(() => {
    const handleMenuChange = (e) => {
      setIsHeaderMenuOpen(e.detail);
    };

    window.addEventListener("menuStateChange", handleMenuChange);
    return () =>
      window.removeEventListener("menuStateChange", handleMenuChange);
  }, []);
  const navigate = useNavigate(); // 2. Navigate function initialize karein

  // Click handler function
  const handleNavigation = (path) => {
    if (path) {
      navigate(path);
    } else {
      console.warn("Path define nahi kiya gaya hai!");
    }
  };
  // Create 4 rows of 3 products each (12 total)
  const allProducts = [];
  for (let i = 0; i < 4; i++) {
    allProducts?.push(...products);
  }

  return (
    <section className="w-full bg-background-main">
      <div className="w-full max-w-[1620px] mx-auto px-4 sm:px-6 lg:px-8 py-[25px] sm:py-[37px] lg:py-[50px]">
        <div className="flex flex-col gap-[25px] sm:gap-[37px] lg:gap-[50px] justify-start items-center w-full">
          {/* Section Title */}
          <h1 className="text-[40px] sm:text-[75px] xl:text-[100px] font-[Parkinsans] font-bold  text-left text-[#343163]">
            Our Product's
          </h1>

          {/* Products Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-[24px] xl:gap-[48px] w-full">
            {products?.map((product, index) => (
              <div key={`${product?.id}-${index}`} className="relative w-full">
                {/* Product Stack Container */}
                <div className="relative w-full  flex justify-center items-end">
                  {/* Product Image */}
                  <img
                    src={product?.image}
                    alt={product?.title}
                    className={`absolute top-0 w-[60%] sm:w-[70%] md:w-[80%] xl:w-auto object-cover rounded-t-2xl transition-all 
  ${isHeaderMenuOpen ? "z-0" : "z-[999]"}`}
                  />
                  {/* Product Info Card */}
                  <div className="relative z-20 w-full flex flex-col justify-end items-center">
                    <div className="card-outer-wrapper w-[80%] sm:w-[100%] h-[400px] sm:h-[600px] md:h-[500px] xl:h-[550px] 2xl:h-[648px] bg-[linear-gradient(153deg,#195939_0%,_#031312_100%)] rounded-2xl p-[20px] sm:p-[22px] lg:p-[30px] pt-[120px] sm:pt-[160px] lg:pt-[200px]  mt-[100px] sm:mt-[120px] xl:mt-[220px]">
                      <div className="flex flex-col gap-[9px] sm:gap-[12px] lg:gap-[15px] justify-end h-full items-center w-full">
                        {/* Product Details */}
                        <div className="flex flex-col justify-start items-center w-full">
                          <p className=" font-[Parkinsans] text-[16px] 2xl:text-[24px] font-medium  text-center text-text-white">
                            {product?.category}
                          </p>
                          <h3 className=" font-[Parkinsans] text-[20px] md:text-[24px]  xl:text-[30px] 2xl:text-[38px] font-bold text-center text-text-white mt-[4px] sm:mt-[6px] lg:mt-[8px]">
                            {product?.title}
                          </h3>
                        </div>

                        {/* Divider Line */}
                        <div className="w-full h-[1px] bg-text-white mt-[9px] sm:mt-[12px]"></div>

                        {/* Weight Info */}
                        <p className="font-[Parkinsans] text-[18px] md:text-[20px] 2xl:text-[24px] font-bold  text-center text-text-white mt-[15px] 2xl:mt-[20px]">
                          {product?.weight}
                        </p>

                        {/* Learn More Button */}
                        <div className="mt-[21px]">
                          <Button
                            text="Learn More"
                            text_font_size="text-[16px] sm:text-[20px] xl:text-[24px]"
                            text_font_family="Parkinsans"
                            text_font_weight="font-semibold"
                            text_line_height="leading-xl"
                            text_text_align="center"
                            text_color="text-text-white"
                            border_border="1px solid #ffffff"
                            border_border_radius="rounded-2xl"
                            padding="t=12px,r=32px,b=12px,l=32px"
                            onClick={() => handleNavigation(product?.path)}
                            layout_width="100%"
                            className="bg-transparent hover:bg-text-white hover:text-[#343163] transition-all duration-200"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProductGrid;
